<script setup>
import BacklinkForm from '@frontJs/components/forms/projectManagement/seo/BacklinkForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, seoBacklinkPlatforms, seoBacklink } =
    defineProps({
        tenant: {
            type: Object,
            required: true,
        },
        websiteVariants: {
            type: Array,
            required: true,
        },
        seoBacklinkPlatforms: {
            type: Array,
            required: true,
        },
        seoBacklink: {
            type: [Object, null],
            required: false,
            default: null,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="seoBacklink">
            Mettre à jour le backlink #{{ seoBacklink.id }} - SEO/GEO - Gestion
            de projet - Datakepler
        </title>

        <title v-else>
            Créer un backlink - SEO/GEO - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="seoBacklink" :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Mettre à jour le backlink #{{
            seoBacklink.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Créer un backlink
    </PageTitle>

    <BacklinkForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :seo-backlink-platforms="seoBacklinkPlatforms"
        :seo-backlink="seoBacklink"
    />
</template>
